export default __webpack_public_path__ + "static/markus-daum-prize-2e50d10f860e3e602ecec01ab9c157a1.png";